<template>
  <div>
    <a href="#" @click.prevent.stop="" v-b-toggle.collapse-2>Informações Receita Federal</a>
    <b-collapse id="collapse-2">
      <b-card>
        <div>
          <h4>Informações gerais</h4>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td>
                  <span class="receita-item-title">CNPJ:</span
                  ><span class="receita-item-desc">{{ receita.cnpj || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Inscrição Estadual:</span
                  ><span class="receita-item-desc">{{ receita.inscricao_estadual || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Nome Empresarial:</span
                  ><span class="receita-item-desc">{{ receita.nome_empresarial || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Nome Fantasia:</span
                  ><span class="receita-item-desc">{{ receita.nome_fantasia || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Telefone:</span
                  ><span class="receita-item-desc">{{ receita.telefone || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">E-mail:</span
                  ><span class="receita-item-desc">{{ receita.email || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Natureza jurídica:</span
                  ><span class="receita-item-desc">{{ receita.natureza_juridica || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Tipo:</span
                  ><span class="receita-item-desc">{{ receita.tipo || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Porte Empresa:</span
                  ><span class="receita-item-desc">{{ receita.porte_empresa || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Regime Tributação:</span
                  ><span class="receita-item-desc">{{ receita.regime_tributacao || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Situação Cnpj:</span
                  ><span class="receita-item-desc">{{ receita.situacao_cnpj || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Situação Ie:</span
                  ><span class="receita-item-desc">{{ receita.situacao_ie || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Tipo Inscrição:</span
                  ><span class="receita-item-desc">{{ receita.tipo_inscricao || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Simples:</span
                  ><span class="receita-item-desc">{{ receita.simples || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Capital Social:</span
                  ><span class="receita-item-desc">{{ receita.capital_social | money }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Data Situação Cadastral:</span
                  ><span class="receita-item-desc">{{
                    receita.data_situacao_cadastral | date
                  }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Ultima Atualização:</span
                  ><span class="receita-item-desc">{{ receita.updated_at | date }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Base de dados:</span
                  ><span class="receita-item-desc">{{ receita.database || '-' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <h4>Endereço</h4>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td>
                  <span class="receita-item-title">Cep:</span
                  ><span class="receita-item-desc">{{ receita.cep | cep }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Logradouro:</span
                  ><span class="receita-item-desc">{{ receita.logradouro || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Numero:</span
                  ><span class="receita-item-desc">{{ receita.numero || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="receita-item-title">Bairro:</span
                  ><span class="receita-item-desc">{{ receita.bairro || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">Município:</span
                  ><span class="receita-item-desc">{{ receita.municipio || '-' }}</span>
                </td>
                <td>
                  <span class="receita-item-title">UF:</span
                  ><span class="receita-item-desc">{{ receita.uf || '-' }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span class="receita-item-title">Complemento:</span
                  ><span class="receita-item-desc">{{ receita.complemento || '-' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <h4>Atividades</h4>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th colspan="2">Atividade principal</th>
              </tr>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
              </tr>
              <tr v-for="p_activity in receita.primary_activity" v-bind:key="p_activity.code">
                <td>{{ p_activity.code | cnae }}</td>
                <td>{{ p_activity.description || '-' }}</td>
              </tr>
              <tr>
                <th colspan="2">
                  {{
                    receita.secondary_activity.length > 1
                      ? 'Atividades secundárias'
                      : 'Atividade secundária'
                  }}
                </th>
              </tr>
              <tr v-for="s_activity in receita.secondary_activity" v-bind:key="s_activity.code">
                <td>{{ s_activity.code | cnae }}</td>
                <td>{{ s_activity.description || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'CustomerReceita',
  props: {
    receita: {
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.receita-item-title {
  font-weight: bold;
  display: block;
}
.receita-item-desc {
  font-size: 12px;
}
.list-group {
  width: 50%;
  float: left;
}
.list-group b {
  display: block;
}
.card {
  border: none;
}
</style>
